// Action types
export const STATUS_DASHBOARD_INGESTS_LOADING = 'STATUS_DASHBOARD_INGESTS_LOADING';
export const STATUS_DASHBOARD_INGESTS_SUCCESS = 'STATUS_DASHBOARD_INGESTS_SUCCESS';
export const STATUS_DASHBOARD_INGESTS_ERROR = 'STATUS_DASHBOARD_INGESTS_ERROR';

export const STATUS_DASHBOARD_TRANSFERS_LOADING = 'STATUS_DASHBOARD_TRANSFERS_LOADING';
export const STATUS_DASHBOARD_TRANSFERS_SUCCESS = 'STATUS_DASHBOARD_TRANSFERS_SUCCESS';
export const STATUS_DASHBOARD_TRANSFERS_ERROR = 'STATUS_DASHBOARD_TRANSFERS_ERROR';

export const STATUS_DASHBOARD_PROXIES_LOADING = 'STATUS_DASHBOARD_PROXIES_LOADING';
export const STATUS_DASHBOARD_PROXIES_SUCCESS = 'STATUS_DASHBOARD_PROXIES_SUCCESS';
export const STATUS_DASHBOARD_PROXIES_ERROR = 'STATUS_DASHBOARD_PROXIES_ERROR';

export const STATUS_DASHBOARD_FAILED_ACTIONS_LOADING = 'STATUS_DASHBOARD_FAILED_ACTIONS_LOADING';
export const STATUS_DASHBOARD_FAILED_ACTIONS_SUCCESS = 'STATUS_DASHBOARD_FAILED_ACTIONS_SUCCESS';
export const STATUS_DASHBOARD_FAILED_ACTIONS_ERROR = 'STATUS_DASHBOARD_FAILED_ACTIONS_ERROR';

export const STATUS_DASHBOARD_CS_PENDING_LOADING = 'STATUS_DASHBOARD_CS_PENDING_LOADING';
export const STATUS_DASHBOARD_CS_PENDING_SUCCESS = 'STATUS_DASHBOARD_CS_PENDING_SUCCESS';
export const STATUS_DASHBOARD_CS_PENDING_ERROR = 'STATUS_DASHBOARD_CS_PENDING_ERROR';

export const STATUS_DASHBOARD_WORK_ORDERS_LOADING = 'STATUS_DASHBOARD_WORK_ORDERS_LOADING';
export const STATUS_DASHBOARD_WORK_ORDERS_SUCCESS = 'STATUS_DASHBOARD_WORK_ORDERS_SUCCESS';
export const STATUS_DASHBOARD_WORK_ORDERS_ERROR = 'STATUS_DASHBOARD_WORK_ORDERS_ERROR';

// Refresh interval in milliseconds (90 seconds)
export const CYCLE_DURATION = 90000;
